import { render, staticRenderFns } from "./Promo2020.vue?vue&type=template&id=7d4fb7a0&scoped=true&"
import script from "./Promo2020.vue?vue&type=script&lang=js&"
export * from "./Promo2020.vue?vue&type=script&lang=js&"
import style0 from "./Promo2020.vue?vue&type=style&index=0&id=7d4fb7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4fb7a0",
  null
  
)

export default component.exports